import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { MaskingService } from './masking.service';
import * as svgSave from 'save-svg-as-png';


@Injectable({
  providedIn: 'root'
})
export class SvgtopngService {
  public base64Mask: string;
  constructor(private maskSvc: MaskingService) { }


 /* public save(): void {
    const holder = this;
    if (!this.maskSvc.loadedMask()) {
      this.maskSvc.mask.d3.selectAll('.completePoly').attr('opacity', 1);
      this.maskSvc.mask.d3.selectAll('.completePoly').attr('visibility', 'visible');
      this.maskSvc.mask.d3.selectAll('circle').attr('opacity', 0);
      this.maskSvc.mask.d3.insert('polygon', ':first-child').attr('class', 'background').style('fill', '#808060')
        .attr('points', '0,0,0,950,1250,950,1250,0').attr('shape-rendering', 'crispEdges');

      svgSave.saveSvgAsPng(this.maskSvc.mask.dom.children[0], this.maskSvc.getCurrentImageUrl().match(/[\w-]+\.(png|jpg)/)[0]
        .replace(/.(png|jpg)/, ''), { width: 1164, height: 874, top: 38, left: 43, encoderOptions: 0.0, scale: (1 / window.devicePixelRatio) }).then(
          () => {
            this.maskSvc.mask.d3.selectAll('.completePoly').attr('opacity', this.maskSvc.currentOpacity);
            this.maskSvc.mask.d3.selectAll('circle').attr('opacity', 1);
            this.maskSvc.mask.d3.selectAll('.background').remove();
          }
        );

    } else {
      this.maskSvc.mask.d3.selectAll('.completePoly').attr('opacity', 1);
      this.maskSvc.mask.d3.selectAll('.completePoly').attr('visibility', 'visible');
      this.maskSvc.mask.d3.selectAll('circle').attr('opacity', 0);
      svgSave.svgAsPngUri(this.maskSvc.mask.dom.children[0], { width: 1164, height: 874, top: 38, left: 43, encoderOptions: 0.0, scale: (1 / window.devicePixelRatio) })
        .then(uri => {
          Jimp.read(this.maskSvc.loadedMaskUrl(), (err, originalMask) => {
            Jimp.read(uri, (err, image) => {
              originalMask.composite(image, 0, 0);
              holder.downloadImage(originalMask);
            });
          });
          this.maskSvc.mask.d3.selectAll('.completePoly').attr('opacity', this.maskSvc.currentOpacity);
          this.maskSvc.mask.d3.selectAll('circle').attr('opacity', 1);
        }
        );
    }
  }*/

 /* public downloadImage(image) {
    image.getBase64(Jimp.AUTO, (err, res) => {
      const download = document.createElement('a');
      download.href = res;
      download.download = this.maskSvc.currentUrl.match(/[\w-]+\.(png|jpg)/)[0];
      download.click();
    });
  }*/


  public base64ToGit(): Promise<string> {
    const holder = this;
    let gitImage;
    if (!this.maskSvc.loadedMask()) {
      this.maskSvc.mask.d3.selectAll('.completePoly').attr('opacity', 1);
      this.maskSvc.mask.d3.selectAll('.completePoly').attr('visibility', 'visible');
      this.maskSvc.mask.d3.selectAll('circle').attr('opacity', 0);
      this.maskSvc.mask.d3.insert('polygon', ':first-child').attr('class', 'background').style('fill', '#808060')
        .attr('points', '0,0,0,950,1250,950,1250,0').attr('shape-rendering', 'crispEdges');
      return svgSave.svgAsPngUri(this.maskSvc.mask.dom.children[0],
        { width: 1164, height: 874, top: 38, left: 43, encoderOptions: 0.0 }).then(
          (image) => {
            gitImage = image;
            this.maskSvc.mask.d3.selectAll('.completePoly').attr('opacity', this.maskSvc.currentOpacity);
            this.maskSvc.mask.d3.selectAll('circle').attr('opacity', 1);
            this.maskSvc.mask.d3.selectAll('.background').remove();
            this.base64Mask = image;
            return image;
          }
        );
    } else {
      this.maskSvc.mask.d3.selectAll('.completePoly').attr('opacity', 1);
      this.maskSvc.mask.d3.selectAll('.completePoly').attr('visibility', 'visible');
      this.maskSvc.mask.d3.selectAll('circle').attr('opacity', 0);
      return svgSave.svgAsPngUri(this.maskSvc.mask.dom.children[0], { width: 1164, height: 874, top: 38, left: 43, encoderOptions: 0.0 })
        .then(uri => {
          return this.compositeImages(this.maskSvc.loadedMaskUrl(), uri).then(compositeResult => {
            this.base64Mask = compositeResult;
            this.maskSvc.mask.d3.selectAll('.completePoly').attr('opacity', this.maskSvc.currentOpacity);
            this.maskSvc.mask.d3.selectAll('circle').attr('opacity', 1);
            return compositeResult;
          });
        }
        );
    }

  }

  public setBase64(image: HTMLImageElement): string {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = image.width;
    canvas.height = image.height;
    ctx.drawImage(image, 0, 0);
    return canvas.toDataURL('image/png');
  }

  private compositeImages(originalMaskUrl: string, newImageUri: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const originalImg = new Image();
      const newImg = new Image();
      
      originalImg.crossOrigin = 'anonymous';
      newImg.crossOrigin = 'anonymous';
      
      let loadedCount = 0;
      
      const onLoad = () => {
        loadedCount++;
        if (loadedCount === 2) {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          
          // Set canvas size to match the images
          canvas.width = originalImg.width;
          canvas.height = originalImg.height;
          
          // Draw original mask first
          ctx.drawImage(originalImg, 0, 0);
          
          // Composite new image on top
          ctx.drawImage(newImg, 0, 0);
          
          // Convert to base64
          const result = canvas.toDataURL('image/png');
          resolve(result);
        }
      };
      
      originalImg.onload = onLoad;
      newImg.onload = onLoad;
      
      originalImg.onerror = () => reject(new Error('Failed to load original mask'));
      newImg.onerror = () => reject(new Error('Failed to load new image'));
      
      originalImg.src = originalMaskUrl;
      newImg.src = newImageUri;
    });
  }
}
